import { Button } from "../../../Button/Default/mod.ts";
import { ThreeButtonType } from "./types.ts";
import { useEffect, useSignal } from "../../../deps.ts";

export const ThreeButtons = (
  {
    primaryButton,
    secondaryButton,
    neutralButton,
    toggleModal,
    isOpened = false,
  }: ThreeButtonType,
) => {
  const isLoading = useSignal(false);
  useEffect(() => {
    isLoading.value = false;
  }, [isOpened]);
  const onClickOnPrimaryButtonHandler = (event: MouseEvent) => {
    if (!primaryButton.isManualToggle) {
      toggleModal();
    } else {
      isLoading.value = true;
    }
    primaryButton.onClick && primaryButton.onClick(event);
  };

  const onClickOnSecondaryButtonHandler = (event: MouseEvent) => {
    if (!secondaryButton.isManualToggle) {
      toggleModal();
    } else {
      isLoading.value = true;
    }
    secondaryButton.onClick && secondaryButton.onClick(event);
  };

  const onClickOnNeutralButtonHandler = (event: MouseEvent) => {
    if (!neutralButton.isManualToggle) {
      toggleModal();
    } else {
      isLoading.value = true;
    }
    neutralButton.onClick && neutralButton.onClick(event);
  };

  return (
    <div className={"flex flex-col sm:flex-row sm:justify-between"}>
      <Button
        variant={"neutral"}
        leadingIcon={neutralButton.leadingIcon}
        trailingIcon={neutralButton.trailingIcon}
        className={"mb-l sm:mb-0"}
        onClick={onClickOnNeutralButtonHandler}
      >
        {neutralButton.text}
      </Button>
      <div className={"grid grid-cols-1 gap-l sm:grid-cols-2"}>
        <Button
          variant={"secondary"}
          leadingIcon={secondaryButton.leadingIcon}
          trailingIcon={secondaryButton.trailingIcon}
          onClick={onClickOnSecondaryButtonHandler}
        >
          {secondaryButton.text}
        </Button>
        <Button
          variant={"primary"}
          leadingIcon={primaryButton.leadingIcon}
          trailingIcon={primaryButton.trailingIcon}
          onClick={onClickOnPrimaryButtonHandler}
        >
          {primaryButton.text}
        </Button>
      </div>
    </div>
  );
};
